import React from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface Props {
  onApprove: (data: any) => void;
  onReject: (data: any) => void;
  data: any;
}

const ActionButtons = ({ onApprove, onReject, data }: Props) => {
  return (
    <ButtonContainer>
      <ApproveButton onClick={() => onApprove(data)}>Approve</ApproveButton>
      <RejectButton onClick={() => onReject(data)}>Reject</RejectButton>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  @media only screen and (max-width: 768px) {
    flex-direction: row;
  }
`;

const ApproveButton = styled.button`
  padding: 0.5rem 0.5rem;
  border-radius: 0.25rem;
  border: none;
  color: white;
  background: ${Colors.appleGreen};
  font-family: "Poppins-Book";
  font-size: 0.75rem;
`;
const RejectButton = styled.button`
  padding: 0.5rem 0.5rem;
  border-radius: 0.25rem;
  border: none;
  color: white;
  background: ${Colors.appleRed};
  font-family: "Poppins-Book";
  font-size: 0.75rem;
`;

export default ActionButtons;
